import React from 'react'
import { Heading } from '@myxplor/ui'

export const NoISSCaseClaims = () => (
  <div>
    <Heading small>No ISS Cases</Heading>
    There are no ISS Cases to show yet
  </div>
)



// WEBPACK FOOTER //
// ./src/iss-case-claims/views/empty.jsx